export default __webpack_public_path__ + "img/payment-icon-active.a6adce2f.svg";